import { MultiCountryData } from '../shared/models/multi-country-data';

export const environment = {
    lastLanguage: 'es',
    currentLanguage: 'es',
    production: true,
    version: '2.1.6.0-20240822-qa',
    captchaKey: '6Lfm628qAAAAAKjmRZV0XfXMwyIh5Lh7txzq6qId',
    test: 'qa',
    googleAnalytics: 'G-L2G7FL9MP3',
    googleAnalyticsTechnical: 'G-JX2GHBQLYG',
    rol: '',
    expressUserData: [],
    pathCertificate: 'assets/certs/public-qa.txt',
    multiCountryData: [] as MultiCountryData[],
    basePath: '/',
    apigoogle: 'AIzaSyBLMW-yZQI4A_mnrDCugdzhMl1RPLjrJ4w',
    linkEntregaPage: 'https://linkdepago.forzadeliveryexpress.com',
    apiLinkEntrega: 'https://backendlinkpago.forzadeliveryexpress.com/api/V1',
    apiBackApp: 'https://backendlinkpago.forzadeliveryexpress.com/app/api/V1',
    linkQrAfiliatePage: 'https://qa-portal.forzadeliveryexpress.com/clubForza/',
    storeLink: 'https://qa-tienda.forzadeliveryexpress.com',
    routes: [
        {
            path: '',
            loadComponent: () =>
                import(
                    '../pages/service-tracking-v2/service-tracking-v2.component'
                ).then((m) => m.ServiceTrackingV2Component),
        },
        {
            path: ':guia',
            loadComponent: () =>
                import(
                    '../pages/service-tracking-v2/service-tracking-v2.component'
                ).then((m) => m.ServiceTrackingV2Component),
        },
        {
            path: ':guia/:val',
            loadComponent: () =>
                import(
                    '../pages/service-tracking-v2/service-tracking-v2.component'
                ).then((m) => m.ServiceTrackingV2Component),
        },
        {
            path: 'pagina-no-encontrada',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
        {
            path: '**',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
    ],
};

export enum Constants {
    api = 'https://qa-rastreo.forzadeliveryexpress.com/fd/Home.aspx/API',
    api2 = 'https://qa-rastreo.forzadeliveryexpress.com/fd/Home.aspx/API',
    apiHN = 'https://qa-rastreo.forzadeliveryexpress.com/fdHN/Home.aspx/API',
    sesionTime = 900000, // 15 * 60 * 1000 = 900000 milisegundos = 15 minutos
    sesionTimeExpress = 32400000, // 9 horas * 60 minutos  * 60 segundos * 1000 milisegundos = 32400000
}
